import { render, staticRenderFns } from "./title-nofoot.vue?vue&type=template&id=30204beb&scoped=true"
import script from "./title-nofoot.vue?vue&type=script&lang=js"
export * from "./title-nofoot.vue?vue&type=script&lang=js"
import style0 from "./title-nofoot.vue?vue&type=style&index=0&id=30204beb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30204beb",
  null
  
)

export default component.exports